<template>
  <div>
    <!--<v-container
			fluid
			grid-list-md
		>
			<v-layout row wrap>
				<GroupCard :model="group" v-for="group in project.available_groups" :key="group.pk"/>
			</v-layout>
    </v-container>-->
    <div v-if="selectedGroup">
      <h3>AG-Einteilung ist abgeschlossen. Deine AG ist:</h3>
      <GroupCard :model="selectedGroup"></GroupCard>
    </div>
    <div v-else>
      <div class="text-xs-center" v-if="!project || !project.available_groups">
        <v-progress-circular indeterminate></v-progress-circular>
      </div>
      <transition-group tag="v-list" class="v-list--two-line" v-else>
        <!-- <draggable v-model="project.available_groups" :options="{'handle': '.handle'}"> -->

        <div v-for="(group, index) in project.available_groups" :key="group.pk">
          <v-list-tile :key="`${group.pk}-tile`" @click.stop="toggleDialog(index, true)">
            <!-- <v-list-tile-action class="handle" style="min-width: 50px">
							<v-icon>reorder</v-icon>
            </v-list-tile-action>-->
            <v-list-tile-action style="min-width: 30px">
              <b>{{index+1}}.</b>
            </v-list-tile-action>
            <v-list-tile-action style="min-width: 30px">
              <v-btn flat icon @click.stop="moveUp(index)">
                <v-icon>expand_less</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-action>
              <v-btn flat icon @click.stop="moveDown(index)">
                <v-icon>expand_more</v-icon>
              </v-btn>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{group.name}}</v-list-tile-title>
              <v-list-tile-sub-title class="text--primary">{{ group.teachers }}</v-list-tile-sub-title>
              <v-list-tile-sub-title>{{ group.description }}</v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-list-tile-action-text>max. {{group.max_member}} Schüler</v-list-tile-action-text>
            </v-list-tile-action>
          </v-list-tile>
          <v-dialog
            :key="`${group.pk}-dialog`"
            v-model="group.showDialog"
            hide-overlay
            fullscreen
            transition="dialog-bottom-transition"
          >
            <GroupCard :model="group" :position="index" :onPositionChange="moveTo">
              <v-toolbar dark color="primary">
                <v-btn icon dark @click="() => {toggleDialog(index, false)}">
                  <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>Details</v-toolbar-title>
              </v-toolbar>
            </GroupCard>
          </v-dialog>
        </div>
        <!-- </draggable> -->
      </transition-group>
      <v-snackbar
        v-for="(userMessage, index) in userMessages"
        :key="index"
        v-model="userMessage.show"
        v-bind="userMessage"
      >{{userMessage.message}}</v-snackbar>
      <div>
        <v-btn style="float: right" color="primary" :loading="submitLoading" @click="submit">
          Speichern
          <v-icon>save</v-icon>
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import GroupCard from "@/components/GroupCard";
import projectApi from "@/services/projectService";
import draggable from "vuedraggable";

export default {
  components: { GroupCard, draggable },
  data() {
    return {
      project: {},
      selectedGroup: undefined,
      projectLoaded: false,
      submitLoading: false,
      userMessages: []
    };
  },
  created() {
    projectApi.fetch(this.$route.params.id).then(project => {
      this.project = project;
      this.projectLoaded = true;
      const queryGroup = +this.$route.query.group;
      if (queryGroup != undefined) {
        const group = this.project.available_groups.find(
          it => it.pk == queryGroup
        );
        if (group) {
          group.showDialog = true;
        }
      }
    });
    projectApi
      .fetchSelectedGroup(this.$route.params.id)
      .then(groups => {
        console.log(groups);
        if (groups.length) {
          this.selectedGroup = groups[0];
        }
      })
      .catch(exc => {
        console.log("no ag selection made", exc);
      });
  },
  computed: {
    priorities() {
      return this.project.available_groups.map(group => group.pk);
    }
  },
  methods: {
    submit() {
      this.submitLoading = true;
      projectApi
        .submitWishes(this.$route.params.id, this.priorities)
        .then(() => {
          this.userMessages.push({
            show: true,
            message: "Prioritäten gespeichert"
          });
          this.submitLoading = false;
        })
        .catch(e => {
          this.userMessages.push({
            show: true,
            message: `Prioritäten konnten nicht gespeichert werden: ${e}`,
            color: "error"
          });
          this.submitLoading = false;
        });
    },
    moveTo(fromIndex, toIndex) {
      console.log("move", "from", fromIndex, "to", toIndex);
      function move(arg, from, to) {
        from = Math.max(Math.min(from, arg.length - 1), 0);
        to = Math.max(Math.min(to, arg.length - 1), 0);
        console.log("move", "from", from, "to", to);

        const array = arg.slice();
        if (to === from) return array;

        var target = array[from];
        var increment = to < from ? -1 : 1;

        for (var k = from; k != to; k += increment) {
          array[k] = array[k + increment];
        }
        array[to] = target;
        return array;
      }
      const newGroups = move(this.project.available_groups, fromIndex, toIndex);
      console.log(
        "new",
        newGroups,
        newGroups.map(it => it.name),
        "old",
        this.project.available_groups,
        this.project.available_groups.map(it => it.name)
      );
      this.$set(this.project, "available_groups", newGroups);
    },
    moveUp(upIndex) {
      if (upIndex == 0) return;
      const oldGroups = this.project.available_groups;
      const newGroups = this.project.available_groups.map((item, index) => {
        if (index + 1 == upIndex) {
          return oldGroups[upIndex];
        }
        if (index == upIndex) {
          return oldGroups[upIndex - 1];
        }
        return item;
      });
      this.$set(this.project, "available_groups", newGroups);
    },
    moveDown(downIndex) {
      if (downIndex == this.project.available_groups.length - 1) return;
      const oldGroups = this.project.available_groups;
      const newGroups = this.project.available_groups.map((item, index) => {
        if (index == downIndex + 1) {
          return oldGroups[downIndex];
        }
        if (index == downIndex) {
          return oldGroups[downIndex + 1];
        }
        return item;
      });
      this.$set(this.project, "available_groups", newGroups);
    },
    toggleDialog(index, state) {
      const group = this.project.available_groups[index];
      this.updateQuery(group, state);
    },
    updateQuery(group, state) {
      this.$router.push({ query: { group: state ? group.pk : undefined } });
    }
  },
  watch: {
    $route: function(to) {
      const groupPk = to.query.group;

      this.project.available_groups.forEach(group => {
        this.$set(group, "showDialog", group.pk == groupPk);
      });
    }
  }
};
</script>

<style>
</style>
